import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AgGridModule } from 'ag-grid-angular';
import { NgxEditorModule } from 'ngx-editor';
import { AgGridPrintService } from './ag-grid-print.service';
import { ClipboardDirective } from './clipboard.directive';
import { CodeEditorComponent } from './code-editor/code-editor.component';
import { ConfirmationModalComponent } from './confirmation-modal/confirmation-modal.component';
import { DigitsOnlyDirective } from './digits-only.directive';
import { ErrorModalComponent } from './error-modal/error-modal.component';
import { FileDropDirective } from './file-drop.directive';
import { HtmlEditorComponent } from './html-editor/html-editor.component';
import { InfiniteScrollerDirective } from './infinite-scroller.directive';
import { InfoModalComponent } from './info-modal/info-modal.component';
import { InstallersModalComponent } from './installers-modal/installers-modal.component';
import { ListComponent } from './list/list.component';
import { LoadingViewComponent } from './loading-view/loading-view.component';
import { MaxValueDirective } from './max-value.directive';
import { MinValueDirective } from './min-value.directive';
import { NgbTimeStructParserPipe } from './ngb-time-struct-parser.pipe';
import { NumberFormatterPipe } from './number-formatter.pipe';
import { NumericStepperComponent } from './numeric-stepper/numeric-stepper.component';
import { SafeHtmlPipe } from './safe-html.pipe';
import { SelectOnFocusDirective } from './select-on-focus.directive';
import { SpinnerComponent } from './spinner/spinner.component';
import { StripHtmlTagsPipe } from './strip-html-tags.pipe';
import { TermsOfUseComponent } from './terms-of-use/terms-of-use.component';
import { ValidationMessageComponent } from './validation-message/validation-message.component';

@NgModule({
  declarations: [
    ValidationMessageComponent,
    NumericStepperComponent,
    MaxValueDirective,
    MinValueDirective,
    SpinnerComponent,
    TermsOfUseComponent,
    ErrorModalComponent,
    LoadingViewComponent,
    InfoModalComponent,
    NumberFormatterPipe,
    ConfirmationModalComponent,
    NgbTimeStructParserPipe,
    HtmlEditorComponent,
    StripHtmlTagsPipe,
    SafeHtmlPipe,
    CodeEditorComponent,
    ClipboardDirective,
    ListComponent,
    InfiniteScrollerDirective,
    FileDropDirective,
    SelectOnFocusDirective,
    DigitsOnlyDirective,
    InstallersModalComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
    NgxEditorModule,
    AgGridModule,
  ],
  exports: [
    ValidationMessageComponent,
    NumericStepperComponent,
    MaxValueDirective,
    MinValueDirective,
    SpinnerComponent,
    TermsOfUseComponent,
    ErrorModalComponent,
    LoadingViewComponent,
    InfoModalComponent,
    NumberFormatterPipe,
    ConfirmationModalComponent,
    NgbTimeStructParserPipe,
    HtmlEditorComponent,
    StripHtmlTagsPipe,
    SafeHtmlPipe,
    CodeEditorComponent,
    ClipboardDirective,
    ListComponent,
    InfiniteScrollerDirective,
    FileDropDirective,
    SelectOnFocusDirective,
    DigitsOnlyDirective,
  ],
  providers: [AgGridPrintService],
})
export class SharedUtilsModule {}
